import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSystemLogin } from '../contexts/SystemLoginContext';
import { createSystemLoginApiClient } from '../utils/systemLoginApi';
import styles from './LoginPage.module.css';
import { WECHAT_CONFIG } from '../config/wechat';

const WechatCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const systemLogin = useSystemLogin();
  const apiClient = createSystemLoginApiClient(systemLogin);
  
  // 使用 ref 来防止重复调用
  const initializationAttempted = useRef(false);
  const isLoginning = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [hasProcessed, setHasProcessed] = useState(false);

  const handleWechatCallback = useCallback(async () => {
    // 防止重复处理
    if (hasProcessed) {
      return;
    }

    if (isLoginning.current) {
      console.log(`正在登录中，跳过重复请求`);
      return;
    }
    isLoginning.current = true;

    try {
      const code = searchParams.get('code');
      // const state = searchParams.get('state');
      const error = searchParams.get('error');

      if (error) {
        throw new Error('微信授权失败');
      }

      if (!code) {
        throw new Error('未获取到授权码');
      }

      console.log('微信回调，获取到code:', code);
      
      // 标记已开始处理
      setHasProcessed(true);
      
      await apiClient.loginWithWechat(code, WECHAT_CONFIG.APP_ID, true);
      
      // 登录成功，跳转到首页或之前的页面
      navigate('/', { replace: true });
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '微信登录失败';
      console.error('微信回调处理失败:', errorMessage);
      setError(errorMessage);
    } finally {
      isLoginning.current = false;
      setIsLoading(false);
    }
  }, [searchParams, navigate, apiClient, hasProcessed]);

  useEffect(() => {
    if (!initializationAttempted.current) {
      initializationAttempted.current = true;
      handleWechatCallback();
    }
  }, [handleWechatCallback]);

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.loginCard}>
            <div className={styles.logoSection}>
              <h2 className={styles.welcomeTitle}>处理微信登录中...</h2>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  border: '4px solid #f3f3f3',
                  borderTop: '4px solid #07C160',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.loginCard}>
            <div className={styles.logoSection}>
              <h2 className={styles.welcomeTitle}>登录失败</h2>
              <p style={{ color: '#ff4444', textAlign: 'center', marginTop: '10px' }}>
                {error}
              </p>
              <button
                onClick={() => navigate('/login')}
                style={{
                  marginTop: '20px',
                  padding: '10px 20px',
                  backgroundColor: '#07C160',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                重新登录
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default WechatCallbackPage; 